module.exports = __webpack_public_path__ + "static/img/Malaysia.81f5134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flag/Malaysia.png
// module id = 7YFj
// module chunks = 1